import axios from "axios";
import { SessionHelper } from "../utilities/sessionHelper";
import TrackHelper from "@/helpers/utilities/TrackHelper";

let skoboApi;
let vueRouter;
var getRequestsMap = {};

export default {
  async get(path, config) {
    if (!skoboApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    if (!path.startsWith("/v")) {
      path = "/v1" + path;
    }

    if (!getRequestsMap[path]) {
      getRequestsMap[path] = new Promise((resolve, reject) => {
        skoboApi
          .get(path, config)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            TrackHelper.registerError(error, error.response.headers);
            reject(error);
          })
          .finally(() => {
            getRequestsMap[path] = null;
          });
      });
    }

    return getRequestsMap[path];
  },

  async post(path, config) {
    if (!skoboApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    if (!path.startsWith("/v")) {
      path = "/v1" + path;
    }

    return await skoboApi.post(path, config);
  },

  async put(path, config) {
    if (!skoboApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    if (!path.startsWith("/v")) {
      path = "/v1" + path;
    }

    return await skoboApi.put(path, config);
  },

  async patch(path, data, config) {
    if (!skoboApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    if (!path.startsWith("/v")) {
      path = "/v1" + path;
    }

    return await skoboApi.patch(path, data, config);
  },

  async delete(path, config) {
    if (!skoboApi) {
      return Promise.reject("Graph Api not initialized yet");
    }

    if (!path.startsWith("/v")) {
      path = "/v1" + path;
    }

    return await skoboApi.delete(path, config);
  },

  async spread(fns) {
    return skoboApi.spread(fns);
  },

  init(router) {
    vueRouter = router;

    skoboApi = axios.create({
      baseURL: import.meta.env.VITE_APP_SKOLEBORDET_API_ENDPOINT
    });

    skoboApi.interceptors.request.use(config => {
      config.headers["Authorization"] = "Bearer " + SessionHelper.nctSessionToken();
      config.headers["RouteName"] = vueRouter.currentRoute.name;
      return config;
    });

    skoboApi.interceptors.response.use(undefined, error => {
      switch (error.response.status) {
        case 401:
          //        sessionLogout();
          break;

        default:
          break;
      }
      return Promise.reject(error);
    });
  }
};
